import { C } from '../../theme/palette';
import { trf } from '../../lib/i18n';

const ETIQUETTES = { avant: 'AVANT', apres: 'APRÈS', pendant: 'PENDANT', probleme: 'PROBLÈME' };

/**
 * Le bureau choisit, photo par photo, ce que le client voit par son lien.
 *
 * <p>Les photos de l'ouvrier arrivent internes : le patron, le technicien ou la
 * secrétaire les passe en revue ici, à côté du lien qu'il envoie, et touche
 * celles à montrer. Les photos montrées sont mises en avant ; les autres restent
 * à disposition, comme preuve, sans quitter le bureau.
 *
 * @param {object} props propriétés du composant
 * @param {object[]} props.photos photos du chantier
 * @param {(id: number|string) => void} props.onBascule montre ou cache une photo au client
 * @returns {JSX.Element} la liste à cocher
 */
export function ChoixPhotosClient({ photos, onBascule }) {
  const liste = (photos || []).filter((p) => p.src);
  const montrees = liste.filter((p) => p.partageClient).length;
  const postes = [...new Set(liste.map((p) => p.poste || 'Général'))];
  return (
    <div>
      <div
        role="status"
        style={{ fontSize: 8.5, color: C.muted, lineHeight: 1.5, marginBottom: 8 }}
      >
        {liste.length === 0
          ? 'Aucune photo sur ce chantier pour le moment.'
          : trf('{0} / {1} photos montrées au client', montrees, liste.length)}
      </div>
      {liste.length > 0 && (
        <div style={{ fontSize: 8.5, color: C.muted, lineHeight: 1.5, marginBottom: 9 }}>
          Touche une photo pour la montrer au client ou la cacher. Les autres restent au bureau,
          comme preuve.
        </div>
      )}
      {postes.map((ps) => (
        <div key={ps} style={{ marginBottom: 9 }}>
          <div style={{ fontSize: 9, fontWeight: 800, color: C.ink, marginBottom: 5 }}>📌 {ps}</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {liste
              .filter((p) => (p.poste || 'Général') === ps)
              .map((p) => (
                <button
                  key={p.id}
                  type="button"
                  aria-pressed={!!p.partageClient}
                  onClick={() => onBascule(p.id)}
                  style={{
                    margin: 0,
                    padding: 0,
                    textAlign: 'left',
                    fontFamily: 'inherit',
                    cursor: 'pointer',
                    background: '#fff',
                    borderRadius: 10,
                    overflow: 'hidden',
                    border: p.partageClient ? '2px solid ' + C.green : '1px solid ' + C.border,
                    position: 'relative',
                  }}
                >
                  <img
                    src={p.src}
                    alt=""
                    style={{
                      width: '100%',
                      height: 84,
                      objectFit: 'cover',
                      display: 'block',
                      opacity: p.partageClient ? 1 : 0.55,
                    }}
                  />
                  {ETIQUETTES[p.cat] && (
                    <span
                      style={{
                        position: 'absolute',
                        top: 5,
                        left: 5,
                        fontSize: 7,
                        fontWeight: 800,
                        color: '#fff',
                        background: p.cat === 'probleme' ? C.red : 'rgba(0,0,0,.5)',
                        borderRadius: 5,
                        padding: '1px 6px',
                      }}
                    >
                      {ETIQUETTES[p.cat]}
                    </span>
                  )}
                  <span style={{ display: 'block', padding: '6px 8px' }}>
                    <span style={{ display: 'block', fontSize: 8, color: C.ink }}>
                      {p.note || ''}
                    </span>
                    <span style={{ display: 'block', fontSize: 7.5, color: C.muted }}>
                      {[p.date, p.h, p.auteur].filter(Boolean).join(' · ')}
                    </span>
                    <span
                      style={{
                        display: 'block',
                        marginTop: 5,
                        borderRadius: 7,
                        padding: 5,
                        textAlign: 'center',
                        fontSize: 8,
                        fontWeight: 800,
                        background: p.partageClient ? C.green : '#eef1f5',
                        color: p.partageClient ? '#fff' : C.grey,
                      }}
                    >
                      {p.partageClient ? '👁 Le client voit' : '🔒 Interne'}
                    </span>
                  </span>
                </button>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}
